module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hant_6-f64629ce6fd6470e8b66d99fa44af2ab.jpg";